<template>
  <Component :is="continuous && !noBaseCard ? BaseCard : 'div'" no-padding :class="containerClasses"
             id="candidateProfileContainer">
    <CandidateProfileFullToggle
      v-if="allowHideFullProfile"
      :open="open"
      @update:open="updateOpen"
    />
    <CandidateProfileDetails
      v-if="!hideProfileDetails"
      :candidate="candidate"
      :continuous="continuous"
      :small="small"
      :editable="editable"
      :show-auto-complete="showAutoComplete"
      @update:banner="(e) => emits('update:banner', e)"
      @update:avatar="(e) => emits('update:avatar', e)"
      @update:candidate="handleUpdateCandidate"
    />
    <CandidateProfileHighlights
      :candidate="candidate"
      :continuous="continuous"
      :muted="muted"
      :small="small"
      :editable="editable"
      @update:candidate="handleUpdateCandidate"
    />
    <CandidateProfileBasicInfo
      :candidate="candidate"
      :continuous="continuous"
      :small="small"
      :editable="editable"
      @update:candidate="handleUpdateCandidate"
    />
    <CandidateProfileCareerPassport
      :candidate="candidate"
      :continuous="continuous"
      :small="small"
      :editable="editable"
      @update:candidate="handleUpdateCandidate"
    />
    <CandidateProfileEducation
      :candidate="candidate"
      :continuous="continuous"
      :small="small"
      :editable="editable"
      @update:candidate="handleUpdateCandidate"
    />
    <CandidateProfileSkillsAndAccomplishments
      :candidate="candidate"
      :continuous="continuous"
      :small="small"
      :editable="editable"
      @update:candidate="handleUpdateCandidate"
    />
    <CandidateProfileSocials
      :candidate="candidate"
      :continuous="continuous"
      :small="small"
      :editable="editable"
      @update:candidate="handleUpdateCandidate"
    />
    <CandidateProfileBadges
      :candidate="candidate"
      :continuous="continuous"
      :small="small"
      :editable="editable"
      @update:candidate="handleUpdateCandidate"
    />
  </Component>
</template>

<script setup>
import BaseCard from "./BaseCard.vue";
import CandidateProfileFullToggle from "./CandidateProfileFullToggle.vue";
import CandidateProfileDetails from "./CandidateProfileDetails.vue";
import CandidateProfileHighlights from "./CandidateProfileHighlights.vue";
import CandidateProfileBasicInfo from "./CandidateProfileBasicInfo.vue";
import CandidateProfileBadges from "./CandidateProfileBadges.vue";
import CandidateProfileCareerPassport from "./CandidateProfileCareerPassport.vue";
import CandidateProfileEducation from "./CandidateProfileEducation.vue";
import CandidateProfileSkillsAndAccomplishments from "./CandidateProfileSkillsAndAccomplishments.vue";
import CandidateProfileSocials from "./CandidateProfileSocials.vue";
import {computed} from "vue";

const emits = defineEmits(["update:open", "update:banner", "update:avatar", "update:candidate"]);
const props = defineProps({
  candidate: Object,
  continuous: Boolean,
  allowHideFullProfile: Boolean,
  open: Boolean,
  small: Boolean,
  muted: Boolean,
  editable: Boolean,
  showAutoComplete: Boolean,
  hideProfileDetails: Boolean,
  noBaseCard: Boolean,
});

const updateOpen = (value) => emits("update:open", value);

const containerClasses = computed(() => {
  return {
    "relative": true,
    "max-h-85vh overflow-y-hidden": props.allowHideFullProfile && !props.open,
    "pb-20": props.allowHideFullProfile && props.open,
  };
});

const handleUpdateCandidate = (value) => emits("update:candidate", value);
</script>
